"use strict";

export default class RoutingProfiles {
  constructor($q, API) {
    this.$q = $q;
    this.API = API;
  }

  //Given a vehicle id, get all routing profiles associated with all this vehicle's vehicle groups
  getVehicleRoutingProfiles(vehicleId, options) {
    let deferred = this.$q.defer();
    let url = "v1/vehicle-groups?vehicleId=" + vehicleId;

    var that = this;

    this.API.get(url, options)
      .success((results) => deferred.resolve(results))
      .error((err) => deferred.reject(err));

    return deferred.promise.then(function(results) {
      var vgPromises = _.map(results, function(result) {
        return that.getRoutingProfiles(result.id, options);
      });
      return that.$q.all(vgPromises).then(function(rpArrayOfArrays) {
        var rpFlatArray = [].concat.apply([], rpArrayOfArrays);
        rpFlatArray = _.uniq(rpFlatArray, function(rp) { return rp.routingProfileId; });
        //console.log("VEHICLE ROUTING PROFILES:");
        //console.log(rpFlatArray);
        return rpFlatArray;
      }, function(error) {
        console.log(error);
        return null;
      });

    }, function(error) {
      console.log(error);
      return null;
    });
  }

  getRoutingProfiles(vehicleGroupId, options) {
    let deferred = this.$q.defer();
    let url = "v1/routing-profiles?includeGroupId=" + vehicleGroupId;

    this.API.get(url, options)
      .success((results) => deferred.resolve(results))
      .error((err) => deferred.reject(err));

    return deferred.promise;
  }

  getRoutingProfile(routingProfileId, options) {
    let deferred = this.$q.defer();
    let url = "v1/routing-profiles/" + routingProfileId;

    this.API.get(url, options)
      .success((results) => deferred.resolve(results))
      .error((err) => deferred.reject(err));

    return deferred.promise;
  }

  getDefaultRoutingProfile(options) {
    let deferred = this.$q.defer();
    let url = "v1/routing-profiles?isDefault=true";

    this.API.get(url, options)
      .success((results) => deferred.resolve(results))
      .error((err) => deferred.reject(err));

    return deferred.promise;
  }

}

RoutingProfiles.$inject = ["$q", "FleetPortalAPI"];



// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-fleetlink/fleetlink.routing-profiles.js